module.exports = __webpack_public_path__ + "web/img/s1.f8ae4fbe.png";